// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2nLAd","footer":"ReportModalFilter_footer__3Kdn8"};